<template>
	<div style="padding: 10px 10px 10px 0;">
		<!-- 新增/修改弹框 -->
		<el-dialog :title="title" :visible.sync="show" width="30%" @close="close">
			<el-form :inline="true" :model="form" ref="form">
				<el-form-item label="区域编号">
					<el-input :disabled="title[0]!='新'" v-model="form.number" placeholder="区域编号"></el-input>
				</el-form-item>
				<el-form-item label="区域名称">
					<el-input :disabled="title[0]=='查'" v-model="form.name" placeholder="区域名称"></el-input>
				</el-form-item>
				<div style="text-align: right;" v-if="title[0]!='查'">
					<el-button type="primary" @click="addIp">添加相机</el-button>
				</div>
				<el-form-item label="选择相机" v-for="(item,index) in form.cameraList">
					<div class="flex">
						<el-select :disabled="title[0]=='查'" v-model="item.id" style="width: 280px;" @change="dis">
							<el-option v-for="item in ips" :label="`ip:${item.ipAddress} 端口:${item.managerPort}`"
								:value="item.id" :disabled="item.disable"></el-option>
						</el-select>
						<el-button  v-if="title[0]!='查'" @click="movIp(index)" type="danger" class="el-icon-delete"></el-button>
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="show=false">取 消</el-button>
				<el-button type="primary" @click="ok" :disabled="disable">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 搜索条件 -->
		<el-form :inline="true" :model="selectForm" ref="selectForm">
			<el-form-item label="区域编号" prop="number">
				<el-input v-model="selectForm.number" placeholder="区域编号"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="getAll">查询</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="$refs.selectForm.resetFields();getAll();">重置</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="addRow">新增</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="dc">导出</el-button>
			</el-form-item>
		</el-form>
		<!-- 表格 -->
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="number" label="区域编号" align="center"></el-table-column>
			<el-table-column prop="name" label="区域名称" align="center"></el-table-column>
			<el-table-column prop="cameraList" label="绑定相机数" align="center">
				<template slot-scope="{row}">{{row.cameraList.length}}</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click="setRow(scope.row,'look')">查看</el-button>
					<el-button type="text" @click="setRow(scope.row,'set')">修改</el-button>
					<el-button type="text" @click="delRow(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 20, 30, 40]"
			:page-size="selectForm.rows" layout="total, sizes, prev, pager, next, jumper" :total="totalNum"
			style="margin-top: 10px;">
		</el-pagination>
	</div>
</template>

<script>
	import publicExport from '../../assets/js/publicExport.js';
	export default {
		data() {
			return {
				form: { //表单数据
					number: "", //区域编号
					name: "", //区域名称
					cameraList: [{
						id: ""
					}], //绑定相机的id
				},
				oldForm: undefined, //表单备份数据
				data: [], //表格数据
				selectForm: { //查询条件
					page: 1, //当前页
					rows: 10, //页大小
					number: "", //编号
				},
				totalNum: 0, //数据总数
				show: false, //控制弹窗
				title: "新增",
				disable: false, //节流
				ips: [] //所有相机
			}
		},
		methods: {
			dc() {
				publicExport("/api/admin/export/uploadSecurityArea", this.selectForm, "区域管理")
			},
			dis() {
				let ids = []
				this.form.cameraList.forEach(item => {
					ids.push(item.id)
				})
				this.ips.forEach(item => {
					if (ids.indexOf(item.id) != -1) {
						item.disable = true
					} else {
						item.disable = false
					}
				})
			},
			addIp() {
				if (this.form.cameraList.length == 0) {
					this.form.cameraList = []
				}
				this.form.cameraList.push({
					id: ""
				})
			},
			movIp(index) {
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.form.cameraList.splice(index, 1)
					this.$message.success("删除成功")
				}).catch(() => {
					this.$message.info("已取消删除")
				});
			},
			ok() {
				let cameraList = []
				this.form.cameraList.forEach(item => {
					this.ips.forEach(i => {
						if (item.id == i.id) {
							cameraList.push(i)
						}
					})
				})
				this.disable = true;
				let url = "/api/area/update"
				if (this.title[0] == "新") {
					url = "/api/area/add"
				}
				this.$http.post(url, {
					...this.form,
					cameraList
				}).then(res => {
					this.disable = false
					if (res.data.code == 0) {
						this.show = false;
						this.$message.success(`${this.title}成功`)
						this.getAll();
					} else {
						this.$message.error(`${this.title}失败`)
					}
				})
			},
			delRow(row) { //删除被点击
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.delete(`/api/area/delete`, {
						params: {
							id: row.id
						}
					}).then(res => {
						if (res.data.code == 0) {
							this.$message.success("删除成功")
							this.getAll();
						} else {
							this.$message.error("删除失败")
						}
					})
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			addRow() { //新增被点击
				this.form = JSON.parse(JSON.stringify(this.oldForm));
				this.title = "新增";
				this.show = true;
			},
			setRow(row,type) { //修改被点击
				this.form = JSON.parse(JSON.stringify(row))
				this.dis()
				this.title = "修改";
				if(type=="look"){
					this.title = "查看";
				}
				this.show = true;
			},
			close() { //弹框关闭
				this.$refs.form.resetFields()
				this.form = JSON.parse(JSON.stringify(this.oldForm));
			},
			getAll() { //获取表格数据
				this.$http.post(`/api/area/selectByPage`, this.selectForm).then(res => {
					this.data = res.data.data.items;
					this.totalNum = res.data.data.totalNum;
				})
			},
			sizeChange(size) { //页大小被修改
				this.selectForm.rows = size;
				this.getAll();
			},
			currentChange(page) { //当前页被修改
				this.selectForm.page = page;
				this.getAll();
			},
			getIp() {
				this.$http.get(`/api/area/selectAllCamera`).then(res => {
					res.data.data.forEach(item => {
						item.disable = false
					})
					this.ips = res.data.data
				})
			}
		},
		created() {
			this.oldForm = JSON.parse(JSON.stringify(this.form))
			this.getAll();
			this.getIp();
		}
	}
</script>

<style scoped="scoped">
</style>
